/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: konstantin
 * Date: 4/23/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Metamenu = Tc.Module.extend({

        config: {},

        on: function (callback) {
            var mod = this;

            mod.handleSearch();
            mod.languageMenu();

            callback();
        },

        handleSearch: function () {
            var $ctx = this.$ctx;
            $('.js-searchico', $ctx).click(function (e) {
                e.preventDefault();
                if(!scent.global.isMobile()) {
                    $(this).hide();
                    $('.js-searchbox').slideToggle("slow");
                } else {
                    $('.search_ico').toggleClass('active');
                    $('.inputwrapper').slideToggle("slow");
                }
            });

            $('.quicksearch').keypress(function (e) {
                var code = e.keyCode ? e.keyCode : e.which;
                if (code.toString() == 13) {
                    var searchquery;
                    if(scent.global.isMobile()) {
                        searchquery = $('.searchquery').last().val();
                    } else {
                        searchquery = $('.searchquery').val();
                    }
                    window.location.hash = encodeURI(searchquery);
                    window.location = $('.searchurl').attr('value') + $('.suffix').attr('value') + '#q=' + encodeURI(searchquery);
                    if(window.location.href.indexOf("#q=") > -1){
                        window.location.reload();
                    }
                    return false;
                }
            });
        },

        languageMenu: function () {
            var $ctx = this.$ctx;
            $('.mod-menulanguage > .langswitch > a', $ctx).click(function (e) {
                if (scent.global.isMobile()) {
					e.preventDefault();
                    $('.mod-menulanguage .language_switch_dropdown').slideToggle("slow");
                }
            });
        }

    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Metamenu.js
// module id = 104
// module chunks = 0